<!---左侧悬浮功能框-->
<!---该功能包含 点赞 收藏 分享--->
<template>
<div class="share-fun">
    <div class="like-cont" :class="{haved:hasThumbUp}" @click="zanChange" >
        <div class="like" ><i class="yk-liked"></i></div>
        <div class="like-count">{{thumbUpTotal}}</div>
    </div>
    <div class="spare-line" ></div>
    <div class="btn-fun collect" @click="favorite" :class="{haved:isFavorite}" >
        <div class="ico" ><i class="yk-collection-o"></i></div>
        <div class="txt">{{isFavorite?'已收藏':'收藏'}}</div>
    </div>
    <div class="">
        <el-popover trigger="hover" placement="left" class="share-popover">
            <div slot="reference">
               <div class="btn-fun  share">
                   <div class="ico"><i class="yk-news_share"></i></div>
                   <div class="txt">分享</div>
               </div>
            </div>

            <div class="qrcode-box">
                <canvas ref="qrCode" class="qrcode"></canvas>
                <div class="">微信扫码分享</div>
            </div>
        </el-popover>
    </div>
</div>
</template>
<script>
import QRCode from 'qrcode';
import {hostBuild} from '@/utils/utils';
export default {
    name:'DiscussionShare',
    props:['data'],
    data(){
        return {
            isClick:false,
           
        }
    },
    computed:{
        hasThumbUp(){
            return this.data.hasGivenThumbUp == 1;
        },
        thumbUpTotal(){
            return this.data.thumbUpTotal;
        },
        isFavorite(){
            return this.data.isFavorite == 1;
        },
        favoriteCount(){
            return this.data.favorite;
        },
        account(){
            return this.$store.getters.user;
        }
    },
    created(){
        
    },
    mounted() {
        this.createQrcode();
   
       
    },
    methods: {
        //点赞操作
        async zanChange(){
            if( this.account.id == undefined){
                window.location.href = hostBuild(`/login?redirect=${window.location.href}`, 'account');
                return false;
            }
            if(this.hasThumbUp){
                //取消
                let result = await this.$axios.post('/subject/v1/subject/drop/thumb/up/from',{subjectId:this.data.id});
                if( result.code == 0 ){
                    this.data['hasGivenThumbUp'] = 0;
                    this.data.thumbUpTotal -=1;
                    this.$success('取消点赞成功!');
                }
            }else{
                let result = await this.$axios.post('/subject/v1/subject/give/thumb/up/to',{subjectId:this.data.id});
                if( result.code == 0 ){
                    this.data['hasGivenThumbUp'] = 1;
                    this.data.thumbUpTotal +=1;
                    this.$success('点赞成功');
                }
            }
        },
        //收藏操作
        async favorite(){
             if( this.account.id == undefined){
                window.location.href = hostBuild(`/login?redirect=${window.location.href}`, 'account');
                return false;
            }
            if( this.isFavorite){
                //取消
                let result = await this.$axios.post('/subject/v1/subject/remove/favorite/item',{subjectIds:[this.data.id]});
                if( result.code == 0 ){
                    this.data.isFavorite = false;
                    this.$success('取消收藏成功!')
                }
            }else{
                let result = await this.$axios.post('/subject/v1/subject/add/favorite/item',{subjectId:this.data.id});
                if( result.code == 0 ){
                    this.data.isFavorite = true;
                    this.$success('收藏成功!')
                }
            }
        },
        /**
         * 生成二维码
         */
        createQrcode() {
            QRCode.toCanvas(this.$refs.qrCode, location.href, { width: 80, margin: 0 });
        },
        
    },
}
</script>
<style lang="less" scoped>
.share-fun{
    position: fixed; z-index: 1000; left: 50%; margin-left: -580px; top: 150px;
}
.qrcode-box{text-align: center; padding:8px 18px;}
.qrcode{width:100px; height: 100px; margin: 0 auto 10px;}
.like-cont{
    .like{
        width: 48px; height: 48px; line-height: 48px; text-align: center; background: #f8f8f8; border-radius: 50%; font-size: 26px; margin-bottom: 5px; cursor: pointer;
        
    }
    text-align: center;
    &.haved{
        color: #e43a3a;
        .like{background: #f6e5e5;}
    }
}
.btn-fun{
    text-align: center;
    &.haved{color: #e43a3a;}
    .ico{font-size: 20px; line-height: 20px;cursor: pointer;
        
    }
    .txt{font-size: 12px; line-height: 17px;}
}
.share{margin-top: 25px;}

.spare-line{height: 1px; width: 24px; margin: 20px auto; background: #e7e7e7;}
</style>